module.exports = __webpack_public_path__ + "static/media/26-6.5e5da253.mp3";